// Pill in the root header. Extracted from App.tsx as part of B.1.5
// Task 1 so the badge persists across all routes, not just /fleet.

import { useQuery } from "@tanstack/react-query";

import { api } from "../../api/client";

export function ServiceStatusBadge() {
  const healthQuery = useQuery({
    queryKey: ["health"],
    queryFn: api.health,
    refetchInterval: 30_000,
  });

  const ok = healthQuery.data?.status === "ok";
  const color = ok ? "var(--ok)" : "var(--crit)";
  const label = healthQuery.isLoading
    ? "Checking…"
    : ok
      ? `API OK · v${healthQuery.data?.version ?? "?"}`
      : "API down";

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "6px 12px",
        background: "var(--surface-2)",
        border: "1px solid var(--border)",
        borderRadius: 999,
        fontSize: "0.8rem",
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: color,
          boxShadow: `0 0 6px ${color}`,
        }}
      />
      {label}
    </div>
  );
}
